var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7682 3.23179C21.6197 3.08338 21.4184 3 21.2085 3C20.9986 3 20.7972 3.08338 20.6488 3.23179L12.5 11.3806L4.35123 3.23179C4.20277 3.08338 4.00144 3 3.79151 3C3.58159 3 3.38026 3.08338 3.23179 3.23179C3.08338 3.38026 3 3.58159 3 3.79151C3 4.00144 3.08338 4.20277 3.23179 4.35123L11.3806 12.5L3.23179 20.6488C3.08338 20.7972 3 20.9986 3 21.2085C3 21.4184 3.08338 21.6197 3.23179 21.7682C3.38026 21.9166 3.58159 22 3.79151 22C4.00144 22 4.20277 21.9166 4.35123 21.7682L12.5 13.6194L20.6488 21.7682C20.7972 21.9166 20.9986 22 21.2085 22C21.4184 22 21.6197 21.9166 21.7682 21.7682C21.9166 21.6197 22 21.4184 22 21.2085C22 20.9986 21.9166 20.7972 21.7682 20.6488L13.6194 12.5L21.7682 4.35123C21.9166 4.20277 22 4.00144 22 3.79151C22 3.58159 21.9166 3.38026 21.7682 3.23179Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconWhite);
export default __webpack_public_path__ + "static/media/closeIconWhite.f18c4cc615a043a9c692de104149e86d.svg";
export { ForwardRef as ReactComponent };